import create from '@verndale/core';
import 'focus-visible';
import modules from './modules';

const isStorybook = !!document.getElementById('storybook-root');
const body = document.querySelector('body') as HTMLBodyElement;

document.addEventListener(
  'DOMContentLoaded',
  async () => {
    // Initialize MSW in development (handles cart API and GraphQL mocks)
    // MSW intercepts at the network level, so requests show in network tab
    if (import.meta.env.DEV) {
      const { startMSW } = await import('./msw');
      await startMSW();
    }

    if (!body.dataset.modulesLoaded || isStorybook) {
      create(modules).then(() => {
        body.dataset.modulesLoaded = 'true';
      });
    }

    // Prevent right-click on images
    document.addEventListener('contextmenu', function (e) {
      if (e.target instanceof HTMLImageElement) {
        e.preventDefault();
      }
    });

    // Prevent dragging images
    document.addEventListener('dragstart', function (e) {
      if (e.target instanceof HTMLImageElement) {
        e.preventDefault();
      }
    });

    const hasPatternOrBackgroundClass = (element: Element | null): boolean =>
      !!element &&
      Array.from(element.classList).some(
        className => className.startsWith('pattern-') || className.startsWith('background-')
      );

    const main = document.querySelector<HTMLElement>('main');
    const sections = Array.from(main?.querySelectorAll<HTMLElement>('section') ?? []);
    const lastSection = sections[sections.length - 1];

    if (
      lastSection &&
      (hasPatternOrBackgroundClass(lastSection) ||
        hasPatternOrBackgroundClass(lastSection.firstElementChild))
    ) {
      lastSection.classList.add('module-extra-bottom');
      main?.classList.add('footer-overlap');
    }
  },
  false
);
